import React, { Fragment } from 'react'

import { Slide } from '../../display_wallet'
import { With2Tabs } from "../../components/With2Tabs"
import Slide_TokkenR_SendRevoke from './Slide_TokkenR_SendRevoke'
import Slide_TokkenR_Create from './Slide_TokkenR_Create'



export default function Slide_TokkenR(props) {

	var jsx_sendRevoke = <Slide_TokkenR_SendRevoke {...props} />
	var jsx_createContract = <Slide_TokkenR_Create		{...props} />

	return (
		<Slide num={props.num} dontaddspacebelow
			style={{ paddingTop: "0px", overflowX: "hidden" }}>
			<With2Tabs
				startingtab="1"
				title_tab1="Envoyer Revoke"
				title_tab2="Créer Contrat"
				content_tab1={jsx_sendRevoke}
				content_tab2={jsx_createContract}
			/>
		</Slide>
	)
}
